<template>
  <div>
    <v-form >
      <div class="form-group">
        <v-text-field color=""  label="Card Number" filled v-cardformat:formatCardNumber prepend-icon="" />
      </div>
      <div class="form-group">
        <label>Card Expiry</label>
        <input class="form-control" v-cardformat:formatCardExpiry>
      </div>
      <div class="form-group">
        <label>Card CVC</label>
        <input class="form-control" v-cardformat:formatCardCVC>
      </div>
      <div class="form-group">
        <label>Numeric input</label>
        <input class="form-control" v-cardformat:restrictNumeric>
      </div>
      <button class="btn btn-primary">Submit</button>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  computed: {
    
  },

}
</script>